import {ValidationModel} from '../../../shared/models/validation-results/validation.model';

export class DisbursementRequestCustomerAccountModel extends ValidationModel {

    // Gets or sets the id
    public id: number;

    // Gets or sets the disbursement request identifier.
    public financeDisbursementRequestId: number;

    // Gets or sets the customer account number identifier.
    public customerAccountNumberId: number;

    // Gets or sets the amount
    public amount: number;

    constructor(json: any) {
        super(json);
        json = this.getBody();

        if (json) {
            this.id = json.id;
            this.financeDisbursementRequestId = json.financeDisbursementRequestId;
            this.customerAccountNumberId = json.customerAccountNumberId;
            this.amount = json.amount;
        }
    }
}
